export default __webpack_public_path__ + "static/media/spotifo.3ced1b82.JPG";